import { Button, Table } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import Home from "./Home";
import { NavLink } from "react-router-dom";
import KwdcHeader from "./LoginHeader";
import { FaEye, FaRegFilePdf } from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios"; // <- Add this
import { config } from "../CommonUtils/CommonURLS"; // <- Add this (adjust path as needed)
import moment from "moment";
import { viewImage } from "../CommonUtils/viewImage";
import PublicSiteFooter from "./PublicSiteFooter";
// import KwdcHeader from './Header';

export default function TendersPage() {
  const [tndrNotifications, setTndrNotifications] = useState([]);

  async function fetchTenderNotifications() {
    try {
      const response = await axios.get(config.url.STU_URL + "ov-public/getTenderNotificationsData");
      if (response?.data?.scode === "01") {
        setTndrNotifications(response?.data?.data || []);
      } else {
        setTndrNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching tender notifications:", error);
    }
  }

  useEffect(() => {
    fetchTenderNotifications();
  }, []);

  return (
    <>
      <KwdcHeader />

      <section className="kwdc-innerpage-about-top mb-0">
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9} className="kwdc-innerpage-about-left">
              <div className="kwdc-innerpage-about-heading">
                <h1>Tenders</h1>
                <p>A.P. State Kapu Welfare & Development Corporation</p>
              </div>
            </Col>

            <Col xxl={4} xl={4} lg={4} md={4} sm={3} xs={3} className="kwdc-about-right"></Col>
          </Row>
        </Container>
      </section>

      {/* =======================================contact us=================================================== */}
      <section className="kwdc-contact-section">
        <Container>
          <div className="table-responsive">
            {/* <Table bordered hover className="affl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>date 1</td>
                  <td>Tender Document</td>
                  <td className="text-center">
                    <FaRegFilePdf size={20} />
                  </td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>date 2</td>
                  <td>Tender Document</td>
                  <td className="text-center">
                    <FaRegFilePdf size={20} />
                  </td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>date 3</td>
                  <td>Tender Document</td>
                  <td className="text-center">
                    <FaRegFilePdf size={20} />
                  </td>
                </tr>
              </tbody>
            </Table> */}
            <Table bordered hover className="affl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date</th>
                  <th>Description</th>
                  <th>View File</th>
                </tr>
              </thead>
              <tbody>
                {tndrNotifications?.length > 0 ? (
                  tndrNotifications.map((item, index) => (
                    <tr key={item.tender_id || index}>
                      <td>{index + 1}</td>
                      <td>{item.tender_notification_date ? moment(item.tender_notification_date).format("DD-MM-YYYY") : "-"}</td>
                      <td>{item.tender_details || "-"}</td>
                      <td className="text-center">
                        {item.tender_file ? (
                          <button type="button" className="btn btn-sm btn-success" onClick={() => viewImage(item.tender_file)}>
                            <FaEye />
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Container>
      </section>

      <PublicSiteFooter />
    </>
  );
}
